import { gql } from 'apollo-angular';

export const RemoveTacticFromFavouriteDocument = gql`
  mutation removeTacticFromFavourites($tacticId: Int!) {
    removeTacticFromFavourites(tacticId: $tacticId)
  }
`;
